module.exports = __webpack_public_path__ + "static/patriciawork4-3b7c6bd50e4b0ef221bed8110bb319db.jpg";